import store from '../store'
import axiosInstance from '../../axios/axiosInstance'
import { apiErrorText } from '../../i18n/apiError'
import { SET_ERRORS, SET_QUIZ, SET_SUBMIT_QUIZ, SET_GENERAL_RESULT } from '../types'

export const getQuiz = async (id: string, level: string) => {
  try {
    const res = await axiosInstance.get(`quiz/?storyId=${id}&level=${level?.toLowerCase() || ''}`)
    const data = res?.data
    if (data && !data.status && !data.statusCode && Object.keys(data) && Object.keys(data).length > 0) {
      const temp: any = []
      const dataQuiz = {
        quiz: data.quiz,
        options: (data.options || []).map((opt, index) => ({ label: opt, value: index + 1 })),
        memberAnswer: data.memberAnswer && { ...data.memberAnswer.data, rightAnswer: data.rightAnswer },
        optionsWithContent: data.optionsWithContent,
        quizContent: data.quizContent,
        allquizopContent: data.optionsWithContent.map((el) => {
          temp.push(...el.opContect, ...data.quizContent)
          return temp
        }),
      }
      store.dispatch({
        type: SET_QUIZ,
        payload: dataQuiz,
      })
      return dataQuiz
    } else {
      store.dispatch({
        type: SET_ERRORS,
        payload: 'Error',
      })
      throw 'Error'
    }
  } catch (error: any) {
    const errMsg = apiErrorText(error) || error?.response?.data?.message?.message || 'Error'
    store.dispatch({
      type: SET_ERRORS,
      payload: errMsg,
    })
    throw errMsg
  }
}

export const submitQuiz = async (id: string, level: string, value: string) => {
  try {
    const content = {
      level: level?.toLowerCase() || '',
      storyId: id,
      answerSelected: value,
    }
    const res = await axiosInstance.post(`quiz`, content)
    const data = res?.data
    if (data && !data.status && Object.keys(data) && Object.keys(data).length > 0) {
      store.dispatch({
        type: SET_SUBMIT_QUIZ,
        payload: data,
      })
      return data
    } else {
      const err = Array.isArray(data?.message) ? data?.message[0] : data?.message
      const errMsg = (err && (err as any)?.message) || err
      store.dispatch({
        type: SET_ERRORS,
        payload: errMsg,
      })
      throw errMsg
    }
  } catch (error: any) {
    const errMsg = apiErrorText(error) || error?.response?.data?.message?.message || 'Error'
    store.dispatch({
      type: SET_ERRORS,
      payload: errMsg,
    })
    throw errMsg
  }
}

export const getGeneralResult = async (id: string) => {
  try {
    const response = await axiosInstance.get(`quiz/result?storyId=${id}`)
    const data = response.data
    if (data && !data.status && data && Object.keys(data) && Object.keys(data).length > 0) {
      store.dispatch({
        type: SET_GENERAL_RESULT,
        payload: data,
      })
      return data
    } else {
      store.dispatch({
        type: SET_ERRORS,
        payload: data?.message?.message || data?.message || 'Error',
      })
      throw data
    }
  } catch (error: any) {
    const errMsg = apiErrorText(error) || error?.response?.data?.message?.message || 'Error'
    store.dispatch({
      type: SET_ERRORS,
      payload: errMsg,
    })
    throw errMsg
  }
}
